import styled from 'styled-components'

const SpacedContainer = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: flex-end;
`

export default SpacedContainer
